import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { api } from "../../utils/index";
import polyglot from "../../utils/polyglot";
import useToast from "./use-toast";

export default function useFetch<T, Error, TData>(query, options = {}) {
  const toast = useToast();
  const queryClient = useQueryClient();
  const key = options.queryKey || [query];
  const res = useQuery<T, Error, TData>({
    queryKey: key,
    queryFn: async () => {
      const { data } = await api.get(query, { params: options.params });
      if (options.apiBackwardCompatibility) {
        return data;
      }
      return data.data;
    },
    ...options,
  });
  useEffect(() => {
    if (res.isError && !options?.shadow) toast.danger(polyglot.t("common.errors.get"));
  }, [res.isError]);

  return {
    ...res,
    isLoading: queryClient.getQueryData(key) ? false : res.isPending || !res.data,
    key: query,
    data: queryClient.getQueryData(key) || res.data,
  };
}
